<template>
  <ul class="navbar-nav mr-auto">
    <li
      class="nav-item"
      v-if="isAuthenticated"
    >
      <div
        class="wp_UserDp"
        v-if="profilePic"
      >
        <img
          :src="profilePic"
          alt="profilePic"
										data-test="authenticatedUserModalImg1"
										id="authenticatedUserModalImg1"
        >
      </div>
      <div
        class="wp_UserDp"
        v-else
      >
<!--        <img-->
<!--          src="@/assets/img/no-profile-image.png"-->
<!--          alt="profilePic"-->
<!--										data-test="authenticatedUserModalImg2"-->
<!--										id="authenticatedUserModalImg2"-->
<!--        >-->
							<svg fill="#fff" height="512pt" viewBox="0 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m437.019531 74.980469c-48.351562-48.351563-112.640625-74.980469-181.019531-74.980469-68.382812 0-132.667969 26.628906-181.019531 74.980469-48.351563 48.351562-74.980469 112.636719-74.980469 181.019531 0 68.378906 26.628906 132.667969 74.980469 181.019531 48.351562 48.351563 112.636719 74.980469 181.019531 74.980469 68.378906 0 132.667969-26.628906 181.019531-74.980469 48.351563-48.351562 74.980469-112.640625 74.980469-181.019531 0-68.382812-26.628906-132.667969-74.980469-181.019531zm-308.679687 367.40625c10.707031-61.648438 64.128906-107.121094 127.660156-107.121094 63.535156 0 116.953125 45.472656 127.660156 107.121094-36.347656 24.972656-80.324218 39.613281-127.660156 39.613281s-91.3125-14.640625-127.660156-39.613281zm46.261718-218.519531c0-44.886719 36.515626-81.398438 81.398438-81.398438s81.398438 36.515625 81.398438 81.398438c0 44.882812-36.515626 81.398437-81.398438 81.398437s-81.398438-36.515625-81.398438-81.398437zm235.042969 197.710937c-8.074219-28.699219-24.109375-54.738281-46.585937-75.078125-13.789063-12.480469-29.484375-22.328125-46.359375-29.269531 30.5-19.894531 50.703125-54.3125 50.703125-93.363281 0-61.425782-49.976563-111.398438-111.402344-111.398438s-111.398438 49.972656-111.398438 111.398438c0 39.050781 20.203126 73.46875 50.699219 93.363281-16.871093 6.941406-32.570312 16.785156-46.359375 29.265625-22.472656 20.339844-38.511718 46.378906-46.585937 75.078125-44.472657-41.300781-72.355469-100.238281-72.355469-165.574219 0-124.617188 101.382812-226 226-226s226 101.382812 226 226c0 65.339844-27.882812 124.277344-72.355469 165.578125zm0 0"/></svg>
      </div>

      <span id="username-welcome-span">
        <span
          class="text-capitalize wp_HeaderMenuItemsText"
          id="authenticatedUserModalSpan1-username-span"
										data-test="authenticatedUserModalSpan1"
        >
          {{getUserData.firstname?getUserData.firstname:'Guest'}}
        </span>
      </span>
    </li>
    <li
      class="nav-item"
      v-else
    >
      <div class="wp_UserDp">
<!--        <img-->
<!--          src="@/assets/img/no-profile-image.png"-->
<!--          alt="profilePic"-->
<!--										data-test="authenticatedUserModalImg3"-->
<!--										id="authenticatedUserModalImg3"-->
<!--        >-->
							<svg fill="#fff" height="512pt" viewBox="0 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m437.019531 74.980469c-48.351562-48.351563-112.640625-74.980469-181.019531-74.980469-68.382812 0-132.667969 26.628906-181.019531 74.980469-48.351563 48.351562-74.980469 112.636719-74.980469 181.019531 0 68.378906 26.628906 132.667969 74.980469 181.019531 48.351562 48.351563 112.636719 74.980469 181.019531 74.980469 68.378906 0 132.667969-26.628906 181.019531-74.980469 48.351563-48.351562 74.980469-112.640625 74.980469-181.019531 0-68.382812-26.628906-132.667969-74.980469-181.019531zm-308.679687 367.40625c10.707031-61.648438 64.128906-107.121094 127.660156-107.121094 63.535156 0 116.953125 45.472656 127.660156 107.121094-36.347656 24.972656-80.324218 39.613281-127.660156 39.613281s-91.3125-14.640625-127.660156-39.613281zm46.261718-218.519531c0-44.886719 36.515626-81.398438 81.398438-81.398438s81.398438 36.515625 81.398438 81.398438c0 44.882812-36.515626 81.398437-81.398438 81.398437s-81.398438-36.515625-81.398438-81.398437zm235.042969 197.710937c-8.074219-28.699219-24.109375-54.738281-46.585937-75.078125-13.789063-12.480469-29.484375-22.328125-46.359375-29.269531 30.5-19.894531 50.703125-54.3125 50.703125-93.363281 0-61.425782-49.976563-111.398438-111.402344-111.398438s-111.398438 49.972656-111.398438 111.398438c0 39.050781 20.203126 73.46875 50.699219 93.363281-16.871093 6.941406-32.570312 16.785156-46.359375 29.265625-22.472656 20.339844-38.511718 46.378906-46.585937 75.078125-44.472657-41.300781-72.355469-100.238281-72.355469-165.574219 0-124.617188 101.382812-226 226-226s226 101.382812 226 226c0 65.339844-27.882812 124.277344-72.355469 165.578125zm0 0"/></svg>
      </div>
      <un-authenticated-models>
      </un-authenticated-models>
    </li>
    <li
      class="nav-item"
      v-if="isAuthenticated"
    >
      <div class="d-flex justify-content-end align-items-center">
        <div class="dropdown wp_HeaderMenuItemsText">
          <button
            class="btn-my-account dropdown-toggle"
            type="button"
            id="authenticatedUserModalBtn1-btnDropdownDemo"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
												data-test="authenticatedUserModalBtn1"
          >
            My Account
          </button>
          <ul
            class="dropdown-menu my-account wp_dropDownClassMyAccount"
            aria-labelledby="btnDropdownDemo"
          >
            <li
              v-for="(pathName, index) in userRouteListPaths"
              :key="index"
              @click="userRoutes(pathName.name)"
              style="cursor: pointer"
														:data-test="'authenticatedUserModalList'+index"
														:id="'authenticatedUserModalList'+index"
            >
              <router-link
                :to="{ name: pathName.name}"
                class="dropdown-item"
                :id="'authenticatedUserModalLink-userprofile-mob-link'+index"
																:data-test="'authenticatedUserModalLink'+index"
              >
                {{pathName.label}}
              </router-link>
            </li>
            <li
              @click="logOut"
              style="cursor: pointer"
														data-test="authenticatedUserModalLogoutList"
														id="authenticatedUserModalLogoutList"
            >
              <a
                class="dropdown-item"
                id="authenticatedUserModalLogoutLink-userLogout-mob-link-header-one"
																data-test="authenticatedUserModalLogoutLink"
              >
                Logout
              </a>
            </li>
          </ul>
        </div>
        <!--<div id="user-dropdwn"-->
        <!--class="region with-flyout"-->
        <!--data-flyout-content=""-->
        <!--&gt;-->
        <!--<div class="flyout cbt-popUp user-flyout">-->
        <!--<ul id="cbt-popUp-1" class="option2">-->
        <!--<li v-for="(pathName, index) in userRouteListPaths"-->
        <!--:key="index"-->
        <!--&gt;-->
        <!--<router-link :to="{ name: pathName.name}"-->
        <!--class="dropdown-item"-->
        <!--:id="'userprofile-mob-link'+index"-->
        <!--&gt;-->
        <!--{{pathName.label}}-->
        <!--</router-link>-->
        <!--</li>-->
        <!--<li>-->
        <!--<a href=""-->
        <!--@click.prevent="logOut"-->
        <!--class="dropdown-item"-->
        <!--id="userLogout-mob-link-header"-->
        <!--&gt;-->
        <!--Logout-->
        <!--</a>-->
        <!--</li>-->
        <!--</ul>-->
        <!--</div>-->
        <!--</div>-->
      </div>
    </li>
    <li class="nav-item">
      <div
        class="region with-flyout country-select"
        data-flyout-content
      >
        <a
          id="authenticatedUserModalCountryLink-ship-to"
          @click.prevent="toggleDropDown('country-select')"
          href
          data-flyout="cbt-popUp"
          :title="getSelectedCountry.country_name"
										data-test="authenticatedUserModalCountryLink"
        >
          <i v-if="(getSelectedCountry && getSelectedCountry.country_flag)"
													data-test="authenticatedUserModalCountryI1" id="authenticatedUserModalCountryI1">
            <img
              :src="getSelectedCountry.country_flag"
              style="width: 32px;"
              :alt="getSelectedCountry.country_name"
              id="authenticatedUserModalCountryImg-country-img"
														data-test="authenticatedUserModalCountryImg"
            >
          </i>
          <i
            class="ae"
            v-else
            id="authenticatedUserModalCountryI2-ae"
												data-test="authenticatedUserModalCountryI2"
          ></i>
        </a>
        <div
          style="display: none;"
          class="wp_countrySelectingContainer"
          id="country-select"
        >
          <!--<ul id="cbt-popUp-one" class="option2">-->
          <!--<li>-->
          <!--<label>-->
          <!--<b id="country-label">Ship to </b>-->
          <!--</label>-->
          <country-picker>
          </country-picker>
          <!--</li>-->
          <!--</ul>-->
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'
import CountryPicker from '@/components/shared/widgets/CountryPicker'
import UnAuthenticatedModels from '@/components/shared/widgets/UnAuthenticatedModels'
import { countrySelector } from '../../../commonJs/CountrySelector'

export default {
	data () {
		return {
			userRouteListPaths: [
				{ name: 'UserProfile', label: 'Profile' },
				{ name: 'Orders', label: 'Orders' },
				{ name: 'WishList', label: 'Wishlist' }
			],
			profilePic: ''
		}
	},
	components: {
		CountryPicker,
		UnAuthenticatedModels
	},
	computed: {
		...mapGetters('user', [
			'getUserData',
			'getProfilePicture',
			'isAuthenticated'
		]),
		...mapGetters('siteData', ['getSelectedCountry', 'getCountriesWithShipping'])
	},
	mounted () {
		this.profilePic = this.getUserData.image_url
	},
	methods: {
		logOut () {
			this.$emit('logOutUser')
		},
		toggleDropDown (dropDownId) {
			countrySelector.toggleDropDown(dropDownId)
			// this.$emit('toggleCountryDropDown', dropDownId);
		},
		userRoutes (to) {
			this.$router.push({
				name: to
			})
		}
	},
	watch: {
		getUserData () {
			this.profilePic = this.getUserData.image_url
		}
	}
}
</script>
